'use client';

import { useJobMutations } from '@/modules/job/contracts';

import { Result } from '@packages/domain-driven';

export const useApplyJob = () => {
	const { jobApplicationMutation } = useJobMutations();

	const submit = async (jobId: string) => {
		try {
			await jobApplicationMutation.mutateAsync({ params: { jobId } });

			return Result.ok(true);
		}
		catch {
			return Result.fail('Unable to apply job');
		}
	};

	return {
		submit,
		...jobApplicationMutation,
	};
};
